"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/inspiroidu/inspiroidu.scss');
const index_1 = require("./index");
const inspiroidu_1 = require("./Sites/inspiroidu");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import site specific scripts
(0, inspiroidu_1.InitInspiroidu)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)();
